<template>
  <div>
    <div class="card-body">
      <div class="row">
        <div class="col-lg-12">
          <table class="table table-sm table-bordered">
            <thead class="bg-custom">
              <tr>
                <th>Sr.No.</th>
                <th>Risk Variable</th>
                <th>Risk Description</th>
                <th>Risk Category</th>
                <th>Score</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in list" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.BPCRP_RISKVARIABLE }}</td>
                <td>{{ item.BPCRP_RISKDESC }}</td>
                <td>
                  <select v-model="item.BPCRP_RISKCATEGORY" class="form-control" @change="getScore(index)">
                    <option v-for="c in categories" :value="c.Title">
                      {{ c.Title }}
                    </option>
                  </select>
                </td>
                <td align="right">
                  {{item.BPCRP_SCORE ? item.BPCRP_SCORE.toLocaleString() : 0}}
                </td>
              </tr>
              <tr>
                <td colspan="4" class="text-right font-weight-bold bg-custom">Total Score:</td>
                <td class="text-right" style="font-weight:bold">{{totalScore.toLocaleString()}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-12">
          <p style="text-align: left;">For <span style="color: forestgreen; font-weight:bold;">Low Risk</span> Score up to 40. For <span style="color: #FFBF00; font-weight: bold;">Medium Risk </span>Score up to 70. and for <span style="color: red; font-weight: bold;">High Risk </span>Score above 70  </p>

        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <h5 style="font-weight:bold">Current Rating of the Customer</h5>
          <div class="row">
            <div class="col-lg-2">
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" v-model="currentLowRisk" type="checkbox" disabled id="customCheckbox4">
                <label for="customCheckbox4" class="custom-control-label">Low</label>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" v-model="currentMeduimRisk" type="checkbox" disabled id="customCheckbox5">
                <label for="customCheckbox5" class="custom-control-label">Meduim</label>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" v-model="currentHighRisk" type="checkbox" disabled id="customCheckbox6">
                <label for="customCheckbox6" class="custom-control-label">High</label>
              </div>
            </div>
          </div>
          <p class="mt-2"><strong>Date:</strong> {{ currentRatingDate }}</p>
        </div>
        <div class="col-md-6 float-right">
          <button @click="showHistory = !showHistory" class="btn btn-primary mb-3">
            {{ showHistory ? 'Hide History' : 'Show Previous Rating of the Customer' }}
          </button>
          <transition name="fade">
            <table v-if="showHistory" class="table table-bordered">
              <thead class="bg-custom">
                <tr>
                  <th>Date</th>
                  <th>Low</th>
                  <th>Medium</th>
                  <th>High</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in history" :key="ind">
                  <td>{{ item.BPCRP_DATE }}</td>
                  <td>{{ item.BPCRP_RISKISLOW ? '✔' : '' }}</td>
                  <td>{{ item.BPCRP_RISKISMEDIUM ? '✔' : '' }}</td>
                  <td>{{ item.BPCRP_RISKISHIGH ? '✔' : '' }}</td>
                </tr>
              </tbody>
            </table>
          </transition>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <button type="button" v-on:click="submitForm" class="btn btn-success float-right mr-1 mt-3">Submit</button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default ({
    props: {
      clientid: Number,
    },
    data() {
      return {
        list: [],
        history: [],
        categories: [],
        history: [],
        ClientID: this.clientid,
        previousRating: '',
        currentRatingDate: '',
        totalScore: 0,
        previousDate: "",
        currentDate: "",
        currentLowRisk: false,
        currentHighRisk: false,
        currentMeduimRisk: false,
        preLowRisk: false,
        preMediumRisk: false,
        preHighRisk: false,
        showHistory: false,
      }
    },
    computed: {
      //lowRisk() {
      //  return this.totalScore <= 40;
      //},
      //mediumRisk() {
      //  return this.totalScore > 40 && this.totalScore <= 70;
      //},
      //highRisk() {
      //  return this.totalScore > 70;
      //},
    },
    created() {
      this.pageLoad();
    },
    methods: {
      pageLoad() {
        var vm = this;
        startReq();
        axios.get("/api/UICApi/pageLoadCRP?ID=" + this.clientid)
          .then(function (res) {
            endReq();
            vm.list = res.data.list;
            vm.history = res.data.history;
            vm.categories = res.data.categories;
            vm.currentRatingDate = res.data.currentDate;
            if (res.data.previousDate != null) {
              vm.previousDate = res.data.previousDate;
            }
            if (res.data.totalScore != 0) {
              vm.totalScore = res.data.totalScore;
              if (res.data.totalScore <= 40) {
                vm.preLowRisk = true;
                vm.preMediumRisk = false;
                vm.preHighRisk = false;
              }
              if (res.data.totalScore > 40 && res.data.totalScore <= 70) {
                vm.preMediumRisk = true;
                vm.preLowRisk = false;
                vm.preHighRisk = false;
              }
              if (res.data.totalScore > 70) {
                vm.preHighRisk = true;
                vm.preMediumRisk = false;
                vm.preLowRisk = false;
              }
              if (res.data.totalScore <= 40) {
                vm.currentLowRisk = true;
                vm.currentMeduimRisk = false;
                vm.currentHighRisk = false;
              }
              if (res.data.totalScore > 40 && res.data.totalScore <= 70) {
                vm.currentMeduimRisk = true;
                vm.currentHighRisk = false;
                vm.currentLowRisk = false;
              }
              if (res.data.totalScore > 70) {
                vm.currentHighRisk = true;
                vm.currentLowRisk = false;
                vm.currentMeduimRisk = false;
              }
            }
          })
          .catch((error) => {
            console.log(error);
            endReq();
          })
      },
      getScore(index) {
        var g = this.list[index];
        var find = this.categories.find(x => x.Title == g.BPCRP_RISKCATEGORY);
        g.BPCRP_SCORE = find.Score;
        this.calculateTotalScore();
      },
      calculateTotalScore() {
        this.totalScore = this.list.reduce((sum, item) => sum + (parseFloat(item.BPCRP_SCORE) || 0), 0);
        if (this.totalScore <= 40) {
          this.currentLowRisk = true;
          this.currentMeduimRisk = false;
          this.currentHighRisk = false;
        }
        else if (this.totalScore > 40 && this.totalScore <= 70) {
          this.currentMeduimRisk = true;
          this.currentHighRisk = false;
          this.currentLowRisk = false;
        }
        else if (this.totalScore > 70) {
          this.currentHighRisk = true;
          this.currentLowRisk = false;
          this.currentMeduimRisk = false;
        }
      },
      submitForm() {
        var vm = this;
        startReq();
        axios.post('/api/UICApi/SaveCustomerRiskProfile', {
          Risk: vm.list,
        })
          .then(response => {
            endReq();
            if (response.data.status) {
              toastr.success(response.data.msg)
            }
            else {
              toastr.error(response.data.msg)
            }
          })
          .catch(error => {
            endReq();
            vm.error = 'Error saving CustomerRiskProfile';
            console.log(error);
          })
      },
    }
  })
</script>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ims/CustomerRiskProfiling.vue